module.exports = __webpack_public_path__ + "img/绿地风车.a221dee5.jpg";